import {
  VuexModule,
  Module,
  Mutation,
  getModule,
} from 'vuex-module-decorators';
import store from '@/store/index';
import { ItemField } from '@/types/type';

type ItemType = { [x: string]: string };

export interface IEditingCardStore {
  // Used when processing each schema.
  name: '' | 'announcement';
  // Get the field with getter to reflect the change of i18n
  fieldGenerationFunction: () => ItemField[];
  editedItem: ItemType;
  dialog: boolean;
  isItemCreated: boolean;
}

@Module({
  dynamic: true,
  store,
  name: 'editingCardStore',
  namespaced: true,
})
export default class EditingCardStore extends VuexModule
  implements IEditingCardStore {
  public name: IEditingCardStore['name'] = '';
  public fieldGenerationFunction: IEditingCardStore['fieldGenerationFunction'] = () => [];
  public editedItem: IEditingCardStore['editedItem'] = {};
  public dialog: IEditingCardStore['dialog'] = false;
  public isItemCreated: IEditingCardStore['isItemCreated'] = true;

  public get fields() {
    return this.fieldGenerationFunction();
  }

  // Normally, the argument of rules is only its own input, but make sure to include the item in the second argument.
  // Since there are times when you want to refer to other fields in validation.
  public get fieldsExtendedRules() {
    return this.fields.map((field: ItemField) => ({
      ...field,
      rules:
        field.rules &&
        field.rules.map(rule => {
          return (val: string) => rule(val, this.editedItem);
        }),
    }));
  }

  @Mutation
  public setName(name: IEditingCardStore['name']) {
    this.name = name;
  }

  @Mutation
  public setFields(fieldsFunc: IEditingCardStore['fieldGenerationFunction']) {
    this.fieldGenerationFunction = fieldsFunc;
  }

  @Mutation
  public editItem(fieldsFunc: IEditingCardStore['fieldGenerationFunction']) {
    this.fieldGenerationFunction = fieldsFunc;
  }

  @Mutation
  public initialize(defaultItem: ItemType) {
    this.editedItem = Object.assign({}, defaultItem);
    this.isItemCreated = true;
    this.dialog = false;
  }

  @Mutation
  public openDialog(arg: { item: ItemType; isItemCreated: boolean }) {
    this.dialog = true;
    this.editedItem = Object.assign({}, arg.item);
    this.isItemCreated = arg.isItemCreated;
  }

  @Mutation
  public updateItem(item: ItemType) {
    this.editedItem = Object.assign({}, item);
  }
}

export const editingCardModule = getModule(EditingCardStore);
